// import Image from "../../../components/Image/Image.component";
import {
  MapContainer,
  ImageOverlay,
  FeatureGroup,
  Polygon,
  Marker,
  Circle,
  useMap,
} from "react-leaflet";
import { useCommanData } from "../../../contexts/commanData.context";
import { Floor } from "./Data";
import { EditControl } from "react-leaflet-draw";
import { useContext, useEffect, useState } from "react";
import "leaflet/dist/leaflet.css";
import "leaflet-draw/dist/leaflet.draw.css";
import { useParams } from "react-router-dom";
import { Get, handleError, Patch } from "../../../utils/fetch.util";
import { UserContext } from "../../../contexts/user.context";
import { toast } from "react-toastify";
import { t } from "i18next";
import { renderToString } from "react-dom/server";
import * as L from "leaflet";
import i18next from "i18next";
import { MdLocationOn, MdComputer, MdFormatSize } from "react-icons/md";
import { RiPlantFill } from "react-icons/ri";
import { IoIosMedkit } from "react-icons/io";
import {
  FaIcons,
  FaFireExtinguisher,
  FaCarSide,
  FaTruck,
} from "react-icons/fa";
import LoadingData from "../../../components/loadingData/loadingData.component";

type Props = {
  handlePinClick?: (point: any) => void;
  getFloor?: () => void;
  floor: Floor;
  image: string;
  status: string;
  pointToEdit?: number;
  selectedPoint?: any;
  key?: string;
  width?: string;
  selectedSegment?: number;
  selectedSector?: number;
  selectedSite?: number;
  selectedService?: number;
  pointValues?: any;
  display_site_layout_3d_point?: (
    segmentId: number,
    sectorId: number,
    siteId: number,
    selectedService: number
  ) => void;
};

const MapEventsHandler = ({ mapData, setMapData }: any) => {
  const map = useMap();

  useEffect(() => {
    const updateMapData = () => {
      const currentZoom = map.getZoom();
      const currentCenter = map.getCenter();
      setMapData({
        zoomLevel: currentZoom,
        center: [currentCenter.lat, currentCenter.lng],
      });
      // console.log("Map data updated:", {
      //   zoomLevel: currentZoom,
      //   center: [currentCenter.lat, currentCenter.lng],
      // });
    };

    // Listen for both zoom and drag events
    map.on("zoomend", updateMapData);
    map.on("moveend", updateMapData);

    // Cleanup event listeners on component unmount
    return () => {
      map.off("zoomend", updateMapData);
      map.off("moveend", updateMapData);
    };
  }, [map]);

  return <></>;
};

export const FloorComponent = ({
  handlePinClick,
  getFloor,
  floor,
  image,
  status,
  pointToEdit,
  key,
  width,
  selectedSegment,
  selectedSector,
  selectedSite,
  selectedService,
  pointValues,
  display_site_layout_3d_point,
}: Props) => {
  const { API_LINK } = useCommanData();
  const { userData, getValidToken } = useContext(UserContext);
  const { siteId, floorId } = useParams();
  const [pointLocations, setPointLocations] = useState<any>(null);
  const [pointLocation, setPointLocation] = useState<any>(null);
  const [resetFloor, setResetFloor] = useState<boolean>(false);
  const [resetAll, setResetAll] = useState<boolean>(false);
  const [selectedOption, setSelectedOption] = useState<string | null>(null);
  const [pointToEditValue, setPointToEditValue] = useState<any>(null);
  const [floorData, setFloorData] = useState<any>(null);
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [mapData, setMapData] = useState<any>({
    zoomLevel: 1,
    center: [0, 0],
  });

  const icons = [
    {
      name: "MdLocationOn",
      icon: <MdLocationOn />,
    },
    {
      name: "RiPlantFill",
      icon: <RiPlantFill />,
    },
    {
      name: "IoIosMedkit",
      icon: <IoIosMedkit />,
    },
    {
      name: "FaFireExtinguisher",
      icon: <FaFireExtinguisher />,
    },
    {
      name: "FaCarSide",
      icon: <FaCarSide />,
    },
    {
      name: "FaTruck",
      icon: <FaTruck />,
    },
    {
      name: "MdComputer",
      icon: <MdComputer />,
    },
  ];

  const sizes = [
    "text-lg",
    "text-xl",
    "text-2xl",
    "text-3xl",
    "text-4xl",
    "text-5xl",
  ];

  const markerIcon = (
    color: string,
    icon: any,
    text: string,
    opacity?: number
  ) =>
    new L.DivIcon({
      className: `custom-icon ${text}`,
      html: `<div style="color: ${color}; opacity: ${opacity ? opacity : 1};">${renderToString(
        icon
      )}</div>`,
    });

  const changeIcon = async (point_id: number, icon: any) => {
    setIsLoading(true);
    const res = await Patch(
      `points/update-point?point_id=${point_id}`,
      {
        site_id: siteId,
        floor_id: floorId,
        asdc_client_contract_id: userData[0].asdc_client_contract_id,
        point_icon: {
          icon: icon.name,
          size: icon.size || "text-xl",
        },
      },
      getValidToken()
    );
    if (res.error) {
      setIsLoading(false);
      handleError(res);
      return;
    }
    getFloor && getFloor();
    setPointToEditValue({
      ...pointToEditValue,
      point_icon: {
        icon: icon.name,
        size: icon.size || "text-xl",
      },
    });
    setResetFloor(!resetFloor);
    toast.success(t("icon_changed_successfully"));
    setIsLoading(false);
  };

  const submitPointLocation = async (pointLocation: any) => {
    setIsLoading(true);
    let body;

    if (pointValues.point_3d_enabled) {
      body = {
        site_id: siteId,
        floor_id: floorId,
        asdc_client_contract_id: userData[0].asdc_client_contract_id,
        point_position_layout: pointLocation,
        point_3d_location: JSON.stringify({
          segment_id: selectedSegment,
          sector_id: selectedSector,
          site_id: selectedSite,
          service_id: selectedService,
        }),
      };
    } else {
      body = {
        site_id: siteId,
        floor_id: floorId,
        asdc_client_contract_id: userData[0].asdc_client_contract_id,
        point_position_layout: pointLocation,
      };
    }

    const res = await Patch(
      `points/update-point?point_id=${pointToEdit}`,
      body,
      getValidToken()
    );
    if (res.error) {
      setIsLoading(false);
      handleError(res);
      return;
    }
    setPointLocations(null);
    setPointLocation(null);
    getFloor && getFloor();
    setResetFloor(!resetFloor);
    toast.success(t("point_located_successfully"));
    setIsLoading(false);
  };
  const removePointLocation = async () => {
    setIsLoading(true);
    const res = await Patch(
      `points/update-point?point_id=${pointToEdit}`,
      {
        site_id: siteId,
        floor_id: floorId,
        asdc_client_contract_id: userData[0].asdc_client_contract_id,
        point_position_layout: [],
      },
      getValidToken()
    );
    if (res.error) {
      setIsLoading(false);
      handleError(res);
      return;
    }
    setPointLocations(null);
    setPointLocation(null);
    getFloor && getFloor();
    setResetFloor(!resetFloor);
    toast.success(t("point_located_successfully"));
    setIsLoading(false);
  };

  useEffect(() => {
    if (pointToEdit && pointLocation && pointLocation.length > 0) {
      submitPointLocation(pointLocation);
    }
    if (pointToEdit && pointLocation && pointLocation.length === 0) {
      removePointLocation();
    }
  }, [pointLocation]);

  useEffect(() => {
    const getFloor = async () => {
      const res = await Get(
        `floors/get-floor?floor_id=${floor.floorId}`,
        getValidToken()
      );
      if (res.error || !res.data) {
        handleError(res);
        return;
      }

      setFloorData(res.data);
    };

    status !== "view" && getFloor();
  }, []);

  useEffect(() => {
    if (pointToEdit && floor) {
      const point = floor?.points?.find(
        (point) => point.point_id == pointToEdit
      );
      setPointToEditValue(point);
      // console.log("point from point log", point)
    } else {
      setPointToEditValue(null);
    }
  }, [pointToEdit, floor]);

  // useEffect(() => {
  //   setMapData({
  //     zoomLevel: 1,
  //     center: [0, 0],
  //   });
  // }, [resetAll, image]);

  // console.log(pointToEditValue, "pointToEditValue");

  return (
    <>
      <div className={`w-full h-full flex justify-center items-center`}>
        <div>
          {isLoading ? (
            <LoadingData />
          ) : (
            <MapContainer
              center={mapData.center}
              zoom={mapData.zoomLevel}
              zoomSnap={0.05}
              className={`${width ? width : "!w-[60vw]"} !h-[65vh] !overflow-hidden`}
              style={{ backgroundColor: "#d7d7dc" }}
              id="mapid"
              key={`${key ? key : ""} ${image} map ${
                pointToEdit ? pointToEdit : ""
              } ${resetFloor ? "true" : "false"} ${resetAll ? "true" : "false"}`}
            >
              {status !== "view" && (
                <FeatureGroup>
                  <EditControl
                    key={
                      pointToEdit !== undefined
                        ? `${pointToEdit}-editControl`
                        : "default-editControl"
                    }
                    position="topright"
                    onCreated={(e) => {
                      // setSearchParams((prev) => {
                      //   prev.set("zoomLevel", zoomLevel.toString());
                      //   return prev;
                      // });
                      if (e.layerType === "polygon") {
                        const latlngs = e.layer.getLatLngs()[0];
                        latlngs.push(latlngs[0]);
                        const pointLocation = latlngs.map(
                          (latlng: { lat: number; lng: number }) => ({
                            latitude: latlng.lat,
                            longitude: latlng.lng,
                          })
                        );
                        pointToEdit && setPointLocation(pointLocation);
                      }
                      if (e.layerType === "marker") {
                        const pointLocation = [
                          {
                            latitude: e.layer.getLatLng().lat,
                            longitude: e.layer.getLatLng().lng,
                          },
                        ];
                        pointToEdit && setPointLocation(pointLocation);
                      }
                      if (e.layerType === "circle") {
                        const pointLocation = [
                          {
                            latitude: e.layer.getLatLng().lat,
                            longitude: e.layer.getLatLng().lng,
                          },
                          {
                            latitude: e.layer.getRadius(),
                            longitude: 0,
                          },
                        ];
                        pointToEdit && setPointLocation(pointLocation);
                      }
                    }}
                    onEdited={() => {
                      // setSearchParams((prev) => {
                      //   prev.set("zoomLevel", zoomLevel.toString());
                      //   return prev;
                      // });
                      console.log("edited");
                    }}
                    onDeleted={(e: any) => {
                      pointToEdit && setPointLocation([]);
                      // setSearchParams((prev) => {
                      //   prev.set("zoomLevel", zoomLevel.toString());
                      //   return prev;
                      // });
                      setPointLocations([]);
                      getFloor && getFloor();
                    }}
                    draw={{
                      rectangle: false,
                      // circle: false,
                      circlemarker: false,
                      // marker: false,
                      polyline: false,
                    }}
                    edit={{
                      remove: false,
                      edit: false,
                    }}
                    onDeleteStop={(e: any) => {
                      console.log(e);
                      pointToEdit && setPointLocation([]);
                    }}
                  />
                </FeatureGroup>
              )}
              {image ? (
                <ImageOverlay
                  bounds={[
                    [-90, -180],
                    [90, 180],
                  ]}
                  url={API_LINK + image}
                  className="!object-contain"
                  key={image + "overlay"}
                />
              ) : (
                <div>You are not have image</div>
              )}
              {pointLocations && status !== "view" && (
                <>
                  {pointLocations.length > 2 && (
                    <Polygon
                      positions={pointLocations ? pointLocations : []}
                      key={pointToEdit !== undefined ? pointToEdit : "default"}
                    />
                  )}
                  {pointLocations.length === 1 && (
                    <Marker
                      position={[
                        pointLocations[0].latitude,
                        pointLocations[0].longitude,
                      ]}
                      key={pointToEdit !== undefined ? pointToEdit : "default"}
                      icon={markerIcon(
                        pointToEditValue?.color || "black",
                        pointToEditValue?.point_icon?.icon
                          ? icons.find(
                              (icon) =>
                                icon.name === pointToEditValue?.point_icon?.icon
                            )?.icon
                          : icons[0].icon,
                        pointToEditValue?.point_icon?.size || "text-xl"
                      )}
                    />
                  )}
                  {pointLocations.length === 2 && (
                    <Circle
                      center={[
                        pointLocations[0].latitude,
                        pointLocations[0].longitude,
                      ]}
                      radius={pointLocations[1].latitude}
                      key={pointToEdit !== undefined ? pointToEdit : "default"}
                    />
                  )}
                </>
              )}
              {floor?.points
                ?.filter((p) => {
                  if (status === "edit" && pointToEdit) {
                    return p.point_id != pointToEdit;
                  }
                  return true;
                })
                .map((point) => {
                  if (
                    point?.location?.length === 0 ||
                    point?.location[0].latitude === undefined ||
                    point?.location[0].latitude === null ||
                    point?.location[0].longitude === undefined ||
                    point?.location[0].longitude === null
                  ) {
                    return;
                  }
                  if (point?.location.length > 2) {
                    return (
                      <Polygon
                        positions={point?.location.map((loc) => [
                          loc.latitude,
                          loc.longitude,
                        ])}
                        key={point?.point_id}
                        color={point.color}
                        fillOpacity={status === "edit" ? 0.1 : 0.3}
                        opacity={status === "edit" ? 0.3 : 0.8}
                        eventHandlers={{
                          click: () => {
                            const currentPoint = floor?.points?.find(
                              (p: any) => p.point_id == point.point_id
                            );

                            if (currentPoint?.point_3d_enabled) {
                              const ids = JSON.parse(
                                currentPoint?.point_3d_location
                              );
                              display_site_layout_3d_point &&
                                display_site_layout_3d_point(
                                  ids.segment_id,
                                  ids.sector_id,
                                  ids.site_id,
                                  ids.service_id
                                );

                              return;
                            }

                            handlePinClick && handlePinClick(point);
                          },
                        }}
                      />
                    );
                  }
                  if (point?.location.length === 2) {
                    return (
                      <Circle
                        center={[
                          point?.location[0].latitude,
                          point?.location[0].longitude,
                        ]}
                        radius={point?.location[1].latitude}
                        key={point?.point_id}
                        color={point.color}
                        fillOpacity={status === "edit" ? 0.1 : 0.3}
                        opacity={status === "edit" ? 0.3 : 0.8}
                        eventHandlers={{
                          click: () => {
                            handlePinClick && handlePinClick(point);
                          },
                        }}
                      />
                    );
                  }
                  if (point?.location.length === 1) {
                    return (
                      <Marker
                        position={[
                          point?.location[0].latitude,
                          point?.location[0].longitude,
                        ]}
                        key={point?.point_id}
                        icon={markerIcon(
                          point.color,
                          point.point_icon?.icon
                            ? icons.find(
                                (icon) => icon.name === point.point_icon?.icon
                              )?.icon
                            : icons[0].icon,
                          point.point_icon?.size || "text-xl",
                          status === "edit" ? 0.3 : 1
                        )}
                        eventHandlers={{
                          click: () => {
                            console.log(point);
                            handlePinClick && handlePinClick(point);
                          },
                        }}
                      />
                    );
                  }
                })}
              {status === "edit" &&
                pointToEdit &&
                floor?.points
                  ?.filter((p) => p.point_id == pointToEdit)
                  .map((point) => {
                    if (
                      point?.location?.length === 0 ||
                      point?.location[0].latitude === undefined ||
                      point?.location[0].latitude === null ||
                      point?.location[0].longitude === undefined ||
                      point?.location[0].longitude === null
                    ) {
                      return;
                    }
                    if (point?.location.length > 2) {
                      return (
                        <Polygon
                          positions={point?.location.map((loc: any) => [
                            loc.latitude,
                            loc.longitude,
                          ])}
                          key={point?.point_id}
                          color={point?.color}
                          fillOpacity={0.5}
                          opacity={0.9}
                          eventHandlers={{
                            click: () => {
                              handlePinClick && handlePinClick(point);
                            },
                          }}
                        />
                      );
                    }
                    if (point?.location.length === 2) {
                      return (
                        <Circle
                          center={[
                            point?.location[0].latitude,
                            point?.location[0].longitude,
                          ]}
                          radius={point?.location[1].latitude}
                          key={point?.point_id}
                          color={point?.color}
                          fillOpacity={0.5}
                          opacity={0.9}
                          eventHandlers={{
                            click: () => {
                              handlePinClick && handlePinClick(point);
                            },
                          }}
                        />
                      );
                    }
                    if (point?.location.length === 1) {
                      return (
                        <Marker
                          position={[
                            point?.location[0].latitude,
                            point?.location[0].longitude,
                          ]}
                          key={point?.point_id}
                          icon={markerIcon(
                            point.color,
                            point.point_icon?.icon
                              ? icons.find(
                                  (icon) => icon.name === point.point_icon?.icon
                                )?.icon
                              : icons[0].icon,
                            point.point_icon?.size || "text-xl"
                          )}
                          eventHandlers={{
                            click: () => {
                              handlePinClick && handlePinClick(point);
                            },
                          }}
                        />
                      );
                    }
                  })}
              <MapEventsHandler mapData={mapData} setMapData={setMapData} />
            </MapContainer>
          )}
        </div>
      </div>
      <div className="fixed w-screen h-screen top-0 left-0 overflow-hidden pointer-events-none">
        {/* ################### */}
        {/* Options Sidebar */}
        <div
          className={`pointer-events-auto absolute top-60 end-0 bg-secondary backdrop-blur-md rounded-lg w-16 duration-300 hover:w-36 flex flex-col gap-2 py-2 items-center shadow-2xl group max-h-[40vh] overflow-y-auto ${
            i18next.language === "en" &&
            (pointToEditValue?.location.length !== 1 || status !== "edit")
              ? "transform opacity-0 translate-x-96"
              : ""
          } ${
            i18next.language === "ar" &&
            (pointToEditValue?.location.length !== 1 || status !== "edit")
              ? "transform opacity-0 -translate-x-96"
              : ""
          }`}
          onClick={(e) => {
            e.stopPropagation();
          }}
        >
          <button
            className={`w-full h-16 rounded-lg flex px-5 items-center gap-2 text-xl text-secondary_text hover:text-text hover:bg-black hover:bg-opacity-10 duration-200 ${
              selectedOption === "icons" ? "bg-black bg-opacity-10" : ""
            }`}
            onClick={() => {
              if (selectedOption === "icons") {
                setSelectedOption(null);
              } else {
                setSelectedOption("icons");
              }
            }}
          >
            <FaIcons />
            <h3 className="group-hover:w-fit w-0 duration-500 overflow-hidden">
              {t("icons")}
            </h3>
          </button>
          <button
            className={`w-full h-16 rounded-lg flex px-5 items-center gap-2 text-xl text-secondary_text hover:text-text hover:bg-black hover:bg-opacity-10 duration-200 ${
              selectedOption === "size" ? "bg-black bg-opacity-10" : ""
            }`}
            onClick={() => {
              if (selectedOption === "size") {
                setSelectedOption(null);
              } else {
                setSelectedOption("size");
              }
            }}
          >
            <MdFormatSize />
            <h3 className="group-hover:w-fit w-0 duration-500 overflow-hidden">
              {t("size")}
            </h3>
          </button>
        </div>
        {/* ################### */}
        {/* Icons */}
        <div
          className={`pointer-events-auto absolute bottom-10 left-1/2 -translate-x-1/2 flex items-center gap-8 flex-shrink duration-500 pb-1 pt-2 px-8 bg-secondary backdrop-blur-md rounded-lg max-w-[70vw] overflow-x-auto ${
            selectedOption === "icons" &&
            pointToEditValue?.location.length === 1 &&
            status === "edit"
              ? ""
              : "transform translate-y-96"
          }`}
          onClick={(e) => {
            e.stopPropagation();
          }}
        >
          {icons.map((icon, index) => {
            const point_icon =
              pointToEditValue?.point_icon?.icon || icons[0].name;
            return (
              <div
                className={`text-2xl flex-1 flex flex-col items-center gap-[1px] p-3 cursor-pointer rounded-lg duration-200 hover:bg-black hover:bg-opacity-10 ${
                  point_icon == icon?.name ? "bg-black bg-opacity-10" : ""
                }`}
                key={index}
                onClick={() => {
                  const iconToSubmit: any = {
                    name: icon.name,
                    size: pointToEditValue?.point_icon?.size || "text-xl",
                  };
                  pointToEdit && changeIcon(pointToEdit, iconToSubmit);
                }}
              >
                {icon.icon}
              </div>
            );
          })}
        </div>
        {/* ################### */}
        {/* sizes */}
        <div
          className={`pointer-events-auto absolute bottom-10 left-1/2 -translate-x-1/2 flex items-center gap-8 flex-shrink duration-500 pb-1 pt-2 px-8 bg-secondary backdrop-blur-md rounded-lg max-w-[70vw] overflow-x-auto ${
            selectedOption === "size" &&
            pointToEditValue?.location.length === 1 &&
            status === "edit"
              ? ""
              : "transform translate-y-96"
          }`}
          onClick={(e) => {
            e.stopPropagation();
          }}
        >
          {sizes.map((size, index) => {
            const sizeName = pointToEditValue?.point_icon?.size || sizes[1];
            const iconName =
              pointToEditValue?.point_icon?.icon || icons[0].name;
            return (
              <div
                className={`text-2xl flex-1 flex flex-col items-center gap-[1px] p-3 cursor-pointer rounded-lg duration-200 hover:bg-black hover:bg-opacity-10 ${
                  sizeName == size ? "bg-black bg-opacity-10" : ""
                }`}
                key={index}
                onClick={() => {
                  const icon = {
                    name: iconName,
                    size: size,
                  };
                  pointToEdit && changeIcon(pointToEdit, icon);
                }}
              >
                {index === 0
                  ? "S"
                  : index === 1
                    ? "M"
                    : index === 2
                      ? "L"
                      : index === 3
                        ? "XL"
                        : index === 4
                          ? "XXL"
                          : "XXXL"}
              </div>
            );
          })}
        </div>
      </div>
    </>
  );
};
